import React from 'react';
import './filter.css';
import LoaderImg from '../../images/ajax_loader.gif'

const FilterResultsButton = (props) => {
        return ((props.isServicesLoading) ?
                <span className='filter-spa-loading-text-container'>
                        <img alt='Loader-spinner' width='20px' height='20px' src={LoaderImg} /><span className='services-loading-text font-size-p5 gotham-xn-book'>Loading</span>
                </span> :
                <div className='filter-view-button'>
                        <button className='button font-size-p5 gotham-xn-book primary-btn padding-dot4-dot5 spa-filter-btn ' data-test-id="view-result" onClick={props.onClick}>
                                View {props.count} Results
                        </button>
                </div>
        )
}

export default FilterResultsButton;